export const defaultErrorDisplayText = {
    errorLabelText: 'Erro',
    connectionTimeoutHeaderText: 'Tempo limite de conexão',
    connectionTimeoutMessageText: 'A conexão excedeu o tempo permitido.',
    timeoutHeaderText: 'Tempo esgotado',
    timeoutMessageText:
        'O rosto não permaneceu dentro do oval no tempo previsto. Tente novamente, certificando-se de preencher completamente o oval com o rosto.',
    faceDistanceHeaderText: 'Movimento detectado',
    faceDistanceMessageText: 'Evite aproximar-se durante a captura.',
    multipleFacesHeaderText: 'Múltiplos rostos detectados',
    multipleFacesMessageText:
        'Certifique-se de que haja apenas um rosto em frente à câmera durante a verificação.',
    clientHeaderText: 'Erro do cliente',
    clientMessageText: 'Falha na verificação devido a um problema no dispositivo.',
    serverHeaderText: 'Erro no servidor',
    serverMessageText:
        'Não foi possível concluir a verificação devido a uma falha no servidor.',
    landscapeHeaderText: 'Modo paisagem não suportado',
    landscapeMessageText:
        'Gire seu dispositivo para o modo retrato (vertical).',
    portraitMessageText:
        'Mantenha seu dispositivo em orientação retrato (vertical) durante toda a verificação.',
    tryAgainText: 'Tentar novamente',
};

export const defaultLivenessDisplayText = {
    cameraMinSpecificationsHeadingText:
    'A câmera não atende às especificações mínimas',
    cameraMinSpecificationsMessageText:
    'A câmera deve ter, no mínimo, resolução de 320×240 e 15 quadros por segundo.',
    cameraNotFoundHeadingText: 'Câmera inacessível',
    cameraNotFoundMessageText:
    'Verifique se uma câmera está conectada e se nenhum outro aplicativo a está usando. Talvez seja necessário ir às configurações, conceder permissão de acesso à câmera e reiniciar o navegador.',
    a11yVideoLabelText: 'Webcam para checagem de vivacidade',
    cancelLivenessCheckText: 'Cancelar verificação de vivacidade',
    goodFitCaptionText: 'Encaixe correto',
    goodFitAltText:
    'Ilustração de um rosto perfeitamente encaixado dentro de um oval.',
    hintCenterFaceText: '',
    hintCenterFaceInstructionText:
    'Instrução: antes de iniciar, posicione a câmera no topo central da tela e alinhe seu rosto ao centro. Quando a verificação começar, um oval aparecerá; aproxime-se até que seu rosto preencha o oval e permaneça parado. Após alguns segundos, a verificação será concluída.',
    hintFaceOffCenterText:
    'Rosto fora do oval, centralize-o na câmera.',
    hintMoveFaceFrontOfCameraText: 'Aproxime o rosto da câmera',
    hintTooManyFacesText:
    'Certifique-se de que apenas um rosto esteja em frente à câmera.',
    hintFaceDetectedText: 'Rosto detectado',
    hintCanNotIdentifyText: 'Aproxime o rosto da câmera',
    hintTooCloseText: 'Afaste-se',
    hintTooFarText: 'Aproxime-se',
    hintConnectingText: 'Conectando...',
    hintVerifyingText: 'Verificando...',
    hintCheckCompleteText: 'Verificação concluída',
    hintIlluminationTooBrightText:
    'Vá para um local com iluminação mais baixa.',
    hintIlluminationTooDarkText:
    'Vá para um local com iluminação mais alta.',
    hintIlluminationNormalText: 'Iluminação adequada',
    hintHoldFaceForFreshnessText: 'Permaneça parado',
    hintMatchIndicatorText: '50% concluído. Continue se aproximando.',
    photosensitivityWarningBodyText:
    'Essa verificação emite flashes coloridos. Use com cautela se você for fotossensível.',
    photosensitivityWarningHeadingText: 'Aviso de fotossensibilidade',
    photosensitivityWarningInfoText:
    'Algumas pessoas podem ter crises epiléticas quando expostas a luzes coloridas. Use com cautela se você, ou alguém da sua família, tiver histórico de epilepsia.',
    photosensitivityWarningLabelText:
    'Mais informações sobre fotossensibilidade',
    photosensitivyWarningBodyText:
    'Essa verificação emite flashes coloridos. Use com cautela se você for fotossensível.',
    photosensitivyWarningHeadingText: 'Aviso de fotossensibilidade',
    photosensitivyWarningInfoText:
    'Algumas pessoas podem ter crises epiléticas quando expostas a luzes coloridas. Use com cautela se você, ou alguém da sua família, tiver histórico de epilepsia.',
    photosensitivyWarningLabelText:
    'Mais informações sobre fotossensibilidade',
    retryCameraPermissionsText: 'Tentar novamente',
    recordingIndicatorText: 'Gravando',
    startScreenBeginCheckText: 'COMEÇAR',
    tooFarCaptionText: 'Muito longe',
    tooFarAltText:
    'Ilustração de um rosto dentro de um oval, com um espaço entre o contorno do rosto e as bordas do oval.',
    waitingCameraPermissionText:
    'Aguardando permissão de acesso à câmera.',
    ...defaultErrorDisplayText

};
  